module.exports = __webpack_public_path__ + "img/eyebrow_female_straight_thin_mask.f139f920.png";